import { Conversation } from "../api";
import { Action, AppState } from "./AppProvider";

// Define the reducer function
export const appStateReducer = (state: AppState, action: Action): AppState => {
    switch (action.type) {
        case "TOGGLE_LIKE_MODAL":
            return { ...state, OpenLikeModal: action.payload };
        case "SET_DISIKE_MODAL":
            return { ...state, OpenDislikeModal: action.payload };
        case "SET_Rating_MODEL":
            return { ...state, RatingModel: action.payload };
        case "SET_Message_Selected":
            return { ...state, MessageSelected: action.payload };
        case "SET_COMMENT":
            return { ...state, Comment: action.payload };
        case "SET_CHECKBOXES":
            return { ...state, Checkboxes: action.payload };
        default:
            return state;
    }
};
